import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle, longTextFormatter, booleanFormatter } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getPresses, deletePress } from '../../../../api/press'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData(presses) {
  let data = []
  for (let i = 0; i < presses.length; ++i) {
      const elem = {}
      elem.title = presses[i].title?.en
      elem.subtitle = presses[i].subtitle?.en || '---'
      elem.content = presses[i].content?.en || '---'
      elem.active = presses[i].active
      elem.createdAt = presses[i].createdAt
      elem.id = presses[i]._id
      data = data.concat(elem)
  }
  return data
}

export default function PressPage() {
  const [data, setData] = useState([])
  const [pressId, setPressId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    return (<>
      <Tooltip title="Edit">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/edit-press/' + cell)}>
          <EditIcon/>
        </Button>
      </Tooltip>
      <Tooltip title="Delete">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setPressId(cell)
            setOpenConfirmDialog(true)
          }}>
          <DeleteIcon/>
        </Button>
      </Tooltip>
    </>)
  }

  const columns = [
    { dataField: 'title', text: 'Title', sort: true },
    { dataField: 'subtitle', text: 'Subtitle', sort: true },
    { dataField: 'content', text: 'Content', formatter: longTextFormatter, sort: true },
    { dataField: 'active', text: 'Active', formatter: booleanFormatter, sort: true },
    { dataField: 'createdAt', text: 'Created at', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getPresses().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get presses.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Presses list'>
          <CardHeaderToolbar>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push('/edit-press')}
              >
                Add new
              </button>
            </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={'Are you sure you want to remove this press?'}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deletePress(pressId).then(res => {
                if (res.status === 204 || res.status === 200) {
                  alertSuccess({  title: 'Deleted!', customMessage: 'Press removed successfully.' })
                  setRefresh(true)
                }
              }).catch(error => {
                alertError({ error: error, customMessage: 'Could not remove press.' })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
